module.exports = __webpack_public_path__ + "static/media/APP_NightWatch_152x174_5.5f4c0b16.png";